<div [class.sidebar]="isDialog">
  <div class="dialog-actions">
    @if (dialogOptions.closable) {
      <button [mat-dialog-close]="componentResult" mat-mini-fab aria-label="Close Sidebar">
        <mat-icon title="Close Sidebar">close</mat-icon>
      </button>
    }

    @if (initialized) {
      <button mat-mini-fab (click)="toggleForm(bidItem, true)"
        [disabled]="!('update' | able: bidItem)">
        <mat-icon>edit</mat-icon>
      </button>
    }
  </div>

  <div class="container">
    <!-- title section -->
    <section class="header">
      <div class="title">
        @if (bidItem?.id) {
          {{bidItem.item}}
        }
        @if (!bidItem?.id) {
          Add Biditem
        }
      </div>
    </section>
    <!-- /title section -->
  </div>

  <mat-tab-group [selectedIndex]="0">
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="material-symbols-outlined" title="Details">
          info
        </span>
      </ng-template>
      <ng-template matTabContent>
        @if (initialized) {
          <ng-container *ngTemplateOutlet="InputFormContent"></ng-container>
        }
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="material-symbols-outlined" title="Headings">
          tour
        </span>
      </ng-template>
      <ng-template matTabContent>
        <app-biditem-headings [bidItem]="bidItem"></app-biditem-headings>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="material-symbols-outlined" title="Fields">
          settings_timelapse
        </span>
      </ng-template>
      <ng-template matTabContent>
        <app-fields entityType="bid-item" context="fields" captureRecentField="true" recordRange="true"
        [entity]="bidItem" [stationProperties]="stationProperties"></app-fields>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <span class="material-symbols-outlined" title="Onsite Tests">
          labs
        </span>
      </ng-template>
      <ng-template matTabContent>
        <app-biditem-internal-tests [bidItem]="bidItem"></app-biditem-internal-tests>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="material-symbols-outlined" title="Site Qty">
          map
        </span>
      </ng-template>
      <ng-template matTabContent>
        <app-biditem-site-quantities [bidItem]="bidItem"></app-biditem-site-quantities>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>


<ng-template #InputFormContent>
  <!-- Input Form -->
  <form [formGroup]="inputForm">
    <div class="container">
      <!-- item section -->
      <section>
        <div class="mat-body-2 row">Item:</div>
        @if (!editing) {
          <div class="mat-body">{{bidItem.item}}</div>
        }
        @if (editing) {
          <mat-form-field>
            <input matInput type="text" autocomplete="off" formControlName="item" [errorStateMatcher]="matcher" />
            @if (inputForm.controls.item.hasError('required')) {
              <mat-error>
                This field is <strong>required</strong>
              </mat-error>
            }
            @if (inputForm.controls.item.hasError('error')) {
              <mat-error>
                {{inputForm.controls.item.errors.error}}
              </mat-error>
            }
          </mat-form-field>
        }
      </section>
      <!-- /item section -->

      <!-- quantity section -->
      <section>
        <div class="mat-body-2 row">Quantity:</div>
        @if (!editing) {
          <div class="mat-body">{{bidItem.quantity}}</div>
        }
        @if (editing) {
          <mat-form-field>
            <input matInput type="number" autocomplete="off" formControlName="quantity" [errorStateMatcher]="matcher" />
            @if (inputForm.controls.quantity.hasError('required')) {
              <mat-error>
                This field is <strong>required</strong>
              </mat-error>
            }
            @if (inputForm.controls.quantity.hasError('error')) {
              <mat-error>
                {{inputForm.controls.quantity.errors.error}}
              </mat-error>
            }
          </mat-form-field>
        }
      </section>
      <!-- /quantity section -->

      <!-- uom section -->
      <section>
        <div class="mat-body-2 row">UOM:</div>
        @if (!editing) {
          <div class="mat-body">{{bidItem.uom}}</div>
        }
        @if (editing) {
          <mat-form-field>
            <input matInput type="text" autocomplete="off" formControlName="uom" [errorStateMatcher]="matcher" />
            @if (inputForm.controls.uom.hasError('required')) {
              <mat-error>
                This field is <strong>required</strong>
              </mat-error>
            }
            @if (inputForm.controls.uom.hasError('error')) {
              <mat-error>
                {{inputForm.controls.uom.errors.error}}
              </mat-error>
            }
          </mat-form-field>
        }
      </section>
      <!-- /uom section -->

      <!-- unit_price section -->
      <section>
        <div class="mat-body-2 row">Unit price:</div>
        @if (!editing) {
          <div class="mat-body">{{bidItem.unit_price}}</div>
        }
        @if (editing) {
          <mat-form-field>
            <input matInput type="number" autocomplete="off" formControlName="unit_price" [errorStateMatcher]="matcher" />
            @if (inputForm.controls.unit_price.hasError('required')) {
              <mat-error>
                This field is <strong>required</strong>
              </mat-error>
            }
            @if (inputForm.controls.unit_price.hasError('error')) {
              <mat-error>
                {{inputForm.controls.unit_price.errors.error}}
              </mat-error>
            }
          </mat-form-field>
        }
      </section>
      <!-- /unit_price section -->



      <!-- record by station -->
      <section>
        <div class="mat-body-2 row">
          <div>Record by station:</div>
          <div class="icons">
            @if (!editing) {
              @if (bidItem?.record_by_station) {
                Yes
              }
              @if (!bidItem?.record_by_station) {
                No
              }
            }
            @if (editing) {
              <mat-slide-toggle formControlName="record_by_station"></mat-slide-toggle>
              @if (inputForm.controls.record_by_station.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.record_by_station.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.record_by_station.errors.error}}
                </mat-error>
              }
            }
          </div>
        </div>
      </section>
      <!-- /record by station -->

      <!-- site_id section -->
      <section>
        <div class="mat-body-2 row">Site:</div>
        @if (!editing) {
          <div class="mat-body capitalize">{{bidItem.site?.name}}</div>
        }
        @if (editing) {
          <mat-form-field>
            <mat-label>Select site</mat-label>
            <mat-select formControlName="site_id" [errorStateMatcher]="matcher">
              @for (site of sites; track site) {
                <mat-option [value]="site.id">
                  <div>{{site.name}}</div>
                </mat-option>
              }
            </mat-select>
            @if (inputForm.controls.site_id.hasError('required')) {
              <mat-error>
                This field is <strong>required</strong>
              </mat-error>
            }
            @if (inputForm.controls.site_id.hasError('error')) {
              <mat-error>
                {{inputForm.controls.site_id.errors.error}}
              </mat-error>
            }
          </mat-form-field>
        }
      </section>
      <!-- /site_id section -->

      <!-- rollup_quantity_editable section -->
      <section>
        <div class="mat-body-2 row">
          <div>Rollup Qty Editable:</div>
          <div class="icons">
            @if (!editing) {
              @if (bidItem?.rollup_quantity_editable) {
                Yes
              }
              @if (!bidItem?.rollup_quantity_editable) {
                No
              }
            }
            @if (editing) {
              <mat-slide-toggle formControlName="rollup_quantity_editable"></mat-slide-toggle>
              @if (inputForm.controls.rollup_quantity_editable.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.rollup_quantity_editable.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.rollup_quantity_editable.errors.error}}
                </mat-error>
              }
            }
          </div>
        </div>
      </section>
      <!-- /rollup_quantity_editable section -->

      <!-- rollup_formula section -->
      <section>
        <div class="mat-body-2 row">Rollup formula:</div>
        @if (!editing) {
          <div class="mat-body capitalize">{{bidItem.rollup_formula}}</div>
        }
        @if (editing) {
          <mat-form-field>
            <input matInput formControlName="rollup_formula" [errorStateMatcher]="matcher" />
            @if (inputForm.controls.rollup_formula.hasError('required')) {
              <mat-error>
                This field is <strong>required</strong>
              </mat-error>
            }
            @if (inputForm.controls.rollup_formula.hasError('error')) {
              <mat-error>
                {{inputForm.controls.rollup_formula.errors.error}}
              </mat-error>
            }
          </mat-form-field>
        }
      </section>
      <!-- /rollup_formula section -->

      <!-- rollup_field_id section -->
      <!-- <section>
      <div class="mat-subheading-1 row">Rollup field:</div>
      <div class="mat-body capitalize" *ngIf="!editing">{{bidItem.rollup_field?.label}}</div>
      <mat-form-field *ngIf="editing">
        <mat-label>Select rollup field</mat-label>
        <mat-select formControlName="rollup_field_id" [errorStateMatcher]="matcher">
          <mat-option *ngFor="let field of bidItem?.fields" [value]="field.id">
            {{field.label}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="inputForm.controls.rollup_field_id.hasError('required')">
          This field is <strong>required</strong>
        </mat-error>
        <mat-error *ngIf="inputForm.controls.rollup_field_id.hasError('error')">
          {{inputForm.controls.rollup_field_id.errors.error}}
        </mat-error>
      </mat-form-field>
    </section> -->
    <!-- /rollup_field_id section -->

    <!-- description section -->
    <section>
      <div class="mat-body-2 row">Description:</div>
      @if (!editing) {
        <div class="mat-body">{{bidItem.description}}</div>
      }
      @if (editing) {
        <mat-form-field>
          <textarea matInput formControlName="description" [errorStateMatcher]="matcher"></textarea>
          @if (inputForm.controls.description.hasError('required')) {
            <mat-error>
              This field is <strong>required</strong>
            </mat-error>
          }
          @if (inputForm.controls.description.hasError('error')) {
            <mat-error>
              {{inputForm.controls.description.errors.error}}
            </mat-error>
          }
        </mat-form-field>
      }
    </section>
    <!-- /description section -->

    <!-- Form Actions -->
    <section>
      @if (editing) {
        <div class="row">
          <button mat-stroked-button color="accent" (click)="save()">
            @if (bidItem?.id) {
              Update
            }
            @if (!bidItem?.id) {
              Create
            }
          </button>
          <button mat-stroked-button (click)="onCancel()">Cancel</button>
        </div>
      }
    </section>
    <!-- Form Actions -->
  </div>
</form>
<!-- /Input form -->
</ng-template>